// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonSize, ButtonTheme} from 'common/components/button/constants';
import {SvgIconEl} from 'common/components/svg-icon';

export const thankYouView = (cap, renewalDate, isIntegrated) => {
  const notIntegratedButtons = (
    <div sel='.thank-you-buttons'>
      <a attrs={{href: `/report?immersive-onboarding=true`}}>
        <ButtonEl
          attrs={{
            theme: ButtonTheme.Primary,
          }}
        >
          Set up Mixpanel
        </ButtonEl>
      </a>
      <a attrs={{href: `https://help.mixpanel.com/hc/en-us/articles/360000857366-Guide-to-Mixpanel-Basics`}}>
        <ButtonEl>Guide to Mixpanel Basics</ButtonEl>
      </a>
    </div>
  );
  const integratedButtons = (
    <div sel='.thank-you-buttons'>
      <a attrs={{href: `/report`}}>
        <ButtonEl
          attrs={{
            theme: ButtonTheme.Primary,
          }}
        >
          Go to Mixpanel
        </ButtonEl>
      </a>
    </div>
  );
  return (
    <div sel='.thank-you-wrapper'>
      <div sel='.thank-you-title'>We're glad you're here</div>
      <div sel='.thank-you-plan-row'>
        <SvgIconEl attrs={{icon: `checkmark`}} />
        <div sel='.thank-you-plan-row-text'>{`Your account now has ${cap}`}</div>
      </div>
      <div sel='.thank-you-plan-row'>
        <SvgIconEl attrs={{icon: `checkmark`}} />
        <div sel='.thank-you-plan-row-text'>{`Your plan renews ${renewalDate}`}</div>
      </div>
      {isIntegrated ? integratedButtons : notIntegratedButtons}
    </div>
  );
};

export const thankYouViewMP2023 = (isIntegrated) => {
  const notIntegratedButtons = (
    <div sel='.thank-you-buttons'>
      <a attrs={{href: `/report?immersive-onboarding=true`}}>
        <ButtonEl
          attrs={{
            theme: ButtonTheme.MarketingPrimary,
            size: ButtonSize.Large,
          }}
        >
          Connect your data
        </ButtonEl>
      </a>
      <a attrs={{href: `https://help.mixpanel.com/hc/en-us/articles/360000857366-Guide-to-Mixpanel-Basics`}}>
        <ButtonEl
          attrs={{
            theme: ButtonTheme.MarketingSecondary,
            size: ButtonSize.Large,
          }}
        >
          Learn how to start
        </ButtonEl>
      </a>
    </div>
  );
  const integratedButtons = (
    <div sel='.thank-you-buttons'>
      <a attrs={{href: `/report`}}>
        <ButtonEl
          attrs={{
            theme: ButtonTheme.MarketingPrimary,
            size: ButtonSize.Large,
          }}
        >
          Go to Mixpanel
        </ButtonEl>
      </a>
    </div>
  );
  return (
    <div sel='.thank-you-wrapper'>
      <div sel='.thank-you-title'>One step closer to&nbsp;truth</div>
      <div sel='.thank-you-text'>
        <span>
          Building is about decision-making. We believe builders have a vision and ideas. Our job is to give you answers
          on the performance of those ideas. Which is why we're focused on building analytics that everyone enjoys
          using.
        </span>
        <span>
          So, thank you for giving us a chance. You can always reach out and get support from our team of builders.
        </span>
      </div>
      {isIntegrated ? integratedButtons : notIntegratedButtons}
    </div>
  );
};
